import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const settingsAutomationRoute: InvariantJiraRoute = {
	name: 'global-automation',
	path: '/jira/settings/automation',
	exact: true,
};
